import { memo } from 'react';

import { CreditsMeterPopover, type CreditsMeterPopoverProps } from '~/components/CreditUsageMeter/CreditsMeterPopover';
import { useSubscriptionContext } from '~/providers/SubscriptionProvider';
import { useCreditStats } from '~/swr-hooks/workspaces/useCreditStats';
import { getGiftCreditsBalance } from '~/utils/creditUtils';
import { getAllowCreditOverage } from '~/utils/getAllowCreditOverage';

export type WorkspaceCreditsMeterPopoverProps = Pick<CreditsMeterPopoverProps, 'className' | 'creditPackModalSource'>;

export const WorkspaceCreditsMeterPopover = memo(
  ({ className, creditPackModalSource }: WorkspaceCreditsMeterPopoverProps) => {
    const { data: creditStats } = useCreditStats();
    const { data: subscription } = useSubscriptionContext();

    if (!creditStats?.allocated) {
      return null;
    }

    return (
      <CreditsMeterPopover
        allocated={creditStats.allocated}
        allowCreditOverage={getAllowCreditOverage(creditStats)}
        className={className}
        creditPackModalSource={creditPackModalSource}
        giftCreditsBalance={getGiftCreditsBalance({
          pricingModel: subscription?.pricingModel,
          statsGiftCreditsBalance: creditStats.giftCreditsBalance,
        })}
        nextCycleStartAt={creditStats.nextCycleStartAt}
        used={creditStats.used}
      />
    );
  },
);

WorkspaceCreditsMeterPopover.displayName = 'WorkspaceCreditsMeterPopover';
